import { useEffect } from 'react';

/**
 * Sets the document title for the current page
 * @param title - Page-specific title (will be prepended to "JuryView")
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    // Set title immediately - shorter format for better tab visibility
    const previousTitle = document.title;
    document.title = `${title} - JuryView`;

    // Cleanup: restore previous title when component unmounts
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}

export default usePageTitle;
